import { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, CardFooter, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { toast } from "react-toastify";

import { confirm } from "components/Confirmation";

import IconButton from "components/IconButton";
import CustomPagination from "components/CustomPagination";
import componenteService from "services/ComponenteService";
import comboService from "services/ComboService";
import AppContext from "AppContext";
import { StatusComponenteEnum, statusComponenteText } from "services/ComponenteService";
import { estadoComponenteText } from "services/ComponenteService";
import { PapelEnum } from "services/PerfilService";
import { TipoContratoEnum } from "services/ContratoService";

export default function Componentes() {
  const { state } = useContext(AppContext)
  const [pagina, setPagina] = useState(1)
  const [paginas, setPaginas] = useState(0)
  const [termo, setTermo] = useState(null)
  const [status, setStatus] = useState(null)
  const [idCruzamento, setIdCruzamento] = useState(null)
  const [idTipoComponente, setIdTipoComponente] = useState(null)
  const [items, setItems] = useState([])
  const [cruzamentos, setCruzamentos] = useState([])
  const [tiposComponente, setTiposComponente] = useState([])
  const [contratos, setContratos] = useState([])
  const [idContrato, setIdContrato] = useState(state?.contrato?.id)
  const navigate = useNavigate()

  const idTipoPerfil = state?.user?.perfil?.idTipo
  const podeGerenciar = (state?.user?.acoes || []).includes('componente.gerenciar')

  const carregar = async () => {
    const res = await componenteService.get(idContrato, idTipoComponente, idCruzamento, termo, status, pagina)
    if (res.success) {
      setItems(res.data.items)
      setPaginas(res.data.paginas)
    }
  }

  useEffect(() => {
    carregar()
  }, [pagina])

  useEffect(() => {
    comboService.tipoComponente().then(res => {
      if (res.success) {
        setTiposComponente(res.data)
      }
    })

    if (idTipoPerfil == PapelEnum.ADMIN) {
      comboService.contrato().then(res => {
        if (res.success) {
          const contratos = res.data.filter(el => el.tipoContrato == TipoContratoEnum.SEMAFORICO)
          setContratos(contratos)
          if (contratos.length == 1)
            setIdContrato(contratos[0].id)
        } else {
          setContratos([])
        }
      })
    }
  }, [])

  useEffect(() => {
    if (!idContrato)
      return
    comboService.cruzamento(idContrato).then(res => {
      if (res.success) {
        setCruzamentos(res.data)
      }
    })
  }, [idContrato])

  const contrato = useMemo(() => {
    if (idTipoPerfil == PapelEnum.ADMIN)
      return contratos.find(el => el.id == idContrato)

    return state.contrato
  }, [idContrato, contratos, idTipoPerfil, state])

  const handleDelete = (item) => {
    console.log('delete')
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          // const res = await empresaService.delete(item.id)
          // if (res.success) {
          //   carregar()
          //   toast("Empresa excluída")
          // } else {
          //   toast("Erro ao excluir a empresa")
          // }
        } catch (ex) {
          toast("Erro ao excluir a empresa")
        }
      }
    })
  }

  const handleSubmit = e => {
    e.preventDefault()
    setPagina(1)
    carregar()
  }

  return (
    <>
      <Container fluid>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h1 className="my-4">Componentes</h1>
          {podeGerenciar && (
            <Link className="btn btn-primary btn-icon" to="/admin/componentes/0">Incluir</Link>
          )}
        </div>

        <Card className="shadow mb-4">
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                {idTipoPerfil == PapelEnum.ADMIN && (
                  <Col xs={3}>
                    <Label>Contratos</Label>
                    <select
                      className="form-control"
                      value={idContrato || ''}
                      onChange={(ev) => setIdContrato(ev.target.value != '' ? +ev.target.value : undefined)}
                    >
                      <option value="">Selecione o contrato</option>
                      {contratos.map(el => (
                        <option key={el.id} value={el.id}>{el.numero}</option>
                      ))}
                    </select>
                  </Col>
                )}
                {(contrato?.tipoContrato == TipoContratoEnum.SEMAFORICO) && (
                  <>
                    <Col>
                      <FormGroup>
                        <Label>Cruzamento</Label>
                        <select className="form-control" value={idCruzamento || ''} onChange={e => setIdCruzamento(e.target.value)}>
                          <option value="">Todos</option>
                          {cruzamentos.map(el => (
                            <option key={el.id} value={el.id}>{el.numero} - {el.endereco}</option>
                          ))}
                        </select>
                      </FormGroup>
                    </Col>
                  </>
                )}
                <Col>
                  <FormGroup>
                    <Label>Nome ou Modelo</Label>
                    <Input type="text" placeholder="Nome ou Modelo" value={termo || ''} onChange={e => setTermo(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Tipos de Componente</Label>
                    <select className="form-control" value={idTipoComponente || ''} onChange={e => setIdTipoComponente(e.target.value)}>
                      <option value="">Todos</option>
                      {tiposComponente.map(el => (
                        <option key={el.id} value={el.id}>{el.descricao}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Status</Label>
                    <select className="form-control" value={status || ''} onChange={e => setStatus(e.target.value)}>
                      <option value="">Todos</option>
                      <option value={StatusComponenteEnum.INSTALADO}>Instalado</option>
                      <option value={StatusComponenteEnum.AGUARDANDO_DEFINICAO}>Aguardando definição</option>
                      <option value={StatusComponenteEnum.ESTOQUE}>Estoque</option>
                      <option value={StatusComponenteEnum.EM_MANUTENCAO}>Em manutenção</option>
                      <option value={StatusComponenteEnum.AGUARDANDO_DESCARTE}>Aguardando descarte</option>
                      <option value={StatusComponenteEnum.DESCARTADO}>Descartado</option>
                    </select>
                  </FormGroup>
                </Col>
                <Col className="d-flex align-items-end justify-content-end">
                  <FormGroup>
                    <Button type="submit" color="primary">Buscar</Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card className="shadow">
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">Contrato</th>
                <th scope="col">QRCode</th>
                <th scope="col">Tipo</th>
                <th scope="col">Modelo</th>
                <th scope="col">Status</th>
                <th scope="col">Estado Conservação</th>
                <th scope="col">Localização</th>
                <th scope="col">Pai</th>
                <th scope="col" style={{ width: 120 }}></th>
              </tr>
            </thead>
            <tbody>
              {items.length == 0 && (
                <tr>
                  <td colSpan={9} className="text-center">Nenhum registro</td>
                </tr>
              )}
              {items.map(el => (
                <tr key={el.id}>
                  <td>{el.contrato}</td>
                  <td>{el.qrCode}</td>
                  <td>{el.tipoComponente}</td>
                  <td>{el.modelo}</td>
                  <td>{statusComponenteText(el.status)}</td>
                  <td>{estadoComponenteText(el.estado)}</td>
                  <td>{
                    el.status == StatusComponenteEnum.INSTALADO ? (
                      <>
                        Cruzamento {el.numeroCruzamento}
                      </>
                    ) : ''
                  }</td>
                  <td>{el.pai?.qrCode || '-'}</td>
                  <td className="d-flex flex-row gap-5px">
                    <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => navigate("/admin/componentes/" + el.id)} />
                    {/* <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => handleDelete(el)} /> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <CardFooter className="py-4">
            <CustomPagination pagina={pagina} paginas={paginas} onChange={setPagina} />
          </CardFooter>
        </Card>
      </Container>
    </>
  )
}